module.exports = __webpack_public_path__ + "static/oremosu-0d6faa9a77dfa53ae461096f63fb3e42.png";